import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import './App.css';
import { PersistGate } from "redux-persist/integration/react";
import ScrollToTop from "./utils/scroll-to-top/scroll-to-top";
import { ConfigProvider } from "antd";
import MainLayout from "./layouts/main-layout/main-layout";
import store, { persistor } from "./redux/store";
import CustomToaster from "./components/custom-toaster/custom-toaster";
import { AbilityProvider } from "./ability/AbilityContext";
import { ChatProvider } from "./context/chat-context";
import GlobalLoader from "./components/global-loader/global-loader";
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs?v=5.3.93';

export function App() {
  return (
    <div className="app">
      <ConfigProvider>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AbilityProvider>
              <BrowserRouter>
                <ChatProvider>
                  <ScrollToTop />
                  <MainLayout />
                  <CustomToaster />
                  <GlobalLoader />
                </ChatProvider>
              </BrowserRouter>
            </AbilityProvider>
          </PersistGate>
        </Provider>
      </ConfigProvider>
    </div>
  );
}

export default App;
